import { LinkStyled } from "./../../shared/styles";
import { ContainerLeftMenuStyled, ContainerLinksStyled } from "./styles";
import { menus } from "./../mockedData";
import { Icons } from "./../../shared/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../shared/button/button";
import { toggleMenu } from "../../redux/reducers/settings";
import { useDispatch, useSelector } from "react-redux";
import { Box, useMediaQuery } from "@mui/material";

export const LeftMenu = () => {
  const { isMenuOpen } = useSelector((state) => state.settings);

  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { pathname } = useLocation();
  const navigate = useNavigate();

  function handleOpenMenu() {
    dispatch(toggleMenu());
  }

  return (
    <ContainerLeftMenuStyled isMobile={isMobile} isMenuOpen={isMenuOpen}>
      {!isMobile && (
        <Button
          startIcon={isMenuOpen ? "ArrowCircleLeft" : "ArrowCircleRight"}
          iconSize={24}
          iconColor={"#0197f6"}
          onClick={handleOpenMenu}
          type={"regular"}
          buttonStyles={{
            zIndex: 10000,
            position: "absolute",
            right: "-10px",
            width: "fit-content !important",
            backgroundColor: "#EDEDED !important",
            borderRadius: "8px",
          }}
        />
      )}
      {!isMobile && (
        <Box
          margin={"0 auto"}
          width={"fit-content"}
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/home")}
        >
          <img src="/logo-tenui.png" alt="Logo Tenui" width={72} />
          {/* <img
            src="/logo-develone-2.png"
            alt="Logo Develone"
            width={72}
          /> */}
        </Box>
      )}
      <ContainerLinksStyled>
        {menus.map((menu) => {
          const IconComponent = Icons[menu.icon];
          const isActive = pathname === `/${menu.title.toLowerCase()}`;

          return (
            <LinkStyled
              key={menu.id}
              href={`/${menu.title.toLowerCase()}`}
              underline="none"
              sx={{
                width: isMenuOpen || isMobile ? "100%" : "fit-content",
                margin: "0 auto",
                fontSize: "14px",
                padding: "8px 16px",
                borderRadius: "8px",
                transition: ".3s",
                color: isActive ? "#EDEDED" : "#0F110C",
                backgroundColor: isActive ? "#0F110C" : "#EDEDED",
                "&:hover": { backgroundColor: "#0F110C", color: "#EDEDED" },
              }}
            >
              <IconComponent size={20} />
              {isMenuOpen || isMobile ? menu.title : ""}
            </LinkStyled>
          );
        })}
      </ContainerLinksStyled>
    </ContainerLeftMenuStyled>
  );
};
